(function () {
    "use strict";

    const opn = document.getElementById("onpagenav");
    const main = document.getElementById("main");

    if (!opn) return;

    // Button elements
    const buttons = {
        onPage: opn.querySelector(".buttons .onpage"),
        relDoc: opn.querySelector(".buttons .reldoc"),
        relPage: opn.querySelector(".buttons .relpage")
    };

    // Link panel elements
    const panels = {
        onPage: opn.querySelector(".links .onpage-links"),
        relDoc: opn.querySelector(".links .reldoc-links"),
        relPage: opn.querySelector(".links .relpage-links")
    };

    const CHEVRON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17"><path d="m3 .5-3 3 5 5-5 5 3 3 8-8z" fill="#a1d0e8" fill-rule="nonzero"></path></svg>`;

    // Helper: Create SVG icon container
    function createIcon() {
        const span = document.createElement("span");
        span.innerHTML = CHEVRON_SVG;
        return span;
    }

    // Helper: Generate slug ID for heading
    function getOrGenerateId(h2) {
        if (h2.id) return h2.id;
        const text = h2.textContent.trim();
        const generatedId = text.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "");
        h2.id = generatedId;
        return generatedId;
    }

    // Updates visible panels based on active button
    function updatePanelVisibility() {
        if (panels.onPage) panels.onPage.classList.toggle("hide", !buttons.onPage?.classList.contains("active"));
        if (panels.relDoc) panels.relDoc.classList.toggle("hide", !buttons.relDoc?.classList.contains("active"));
        if (panels.relPage) panels.relPage.classList.toggle("hide", !buttons.relPage?.classList.contains("active"));
    }

    // Sets active state on selected tab button
    function setActiveTab(activeBtn) {
        Object.values(buttons).forEach(btn => {
            if (!btn) return;
            const isActive = btn === activeBtn;
            btn.classList.toggle("active", isActive);
            btn.setAttribute("aria-selected", isActive ? "true" : "false");
        });
        updatePanelVisibility();
    }

    // Initialize On-Page Nav Links
    if (main && panels.onPage) {
        const visibleH2s = Array.from(main.querySelectorAll("h2")).filter(h2 => h2.checkVisibility?.() ?? true);

        if (visibleH2s.length > 0) {
            const row = document.createElement("div");
            row.className = "row";

            const fragment = document.createDocumentFragment();

            visibleH2s.forEach(h2 => {
                const id = getOrGenerateId(h2);
                const linkText = h2.textContent.trim();

                const link = document.createElement("a");
                link.href = `#${id}`;
                link.textContent = linkText;

                const col = document.createElement("div");
                col.className = "col-xl-6";
                col.appendChild(createIcon());
                col.appendChild(link);

                fragment.appendChild(col);
            });

            row.appendChild(fragment);
            panels.onPage.appendChild(row);
        } else {
            // Hide On-Page Nav button if no H2s present and fallback to next tab
            if (buttons.onPage) {
                buttons.onPage.classList.remove("active");
                buttons.onPage.setAttribute("aria-selected", "false");
                buttons.onPage.style.display = "none";
            }
            panels.onPage.classList.add("hide");

            if (buttons.relDoc) {
                buttons.relDoc.classList.add("active");
                buttons.relDoc.setAttribute("aria-selected", "true");
            } else if (buttons.relPage) {
                buttons.relPage.classList.add("active");
                buttons.relPage.setAttribute("aria-selected", "true");
            } else {
                const linksContainer = opn.querySelector(".links");
                if (linksContainer) linksContainer.style.display = "none";
            }
        }

        updatePanelVisibility();
    }

    // Attach Event Listeners
    Object.values(buttons).forEach(btn => {
        btn?.addEventListener("click", (e) => {
            e.preventDefault();
            setActiveTab(btn);
        });
    });
})();